module.exports = __webpack_public_path__ + "static/media/350Mbps.0bfac942.bin";